import React from 'react';
import MainContent from 'components/HomePageNew/MainContent';
import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';

const HomePageNew = ({ ...props }) => {

  return (
    <HeaderFooterLayout>
      <MainContent {...props} />
    </HeaderFooterLayout>
  );
};

export default HomePageNew;
